import { ValueTypes } from './ValueTypes';

export function getUnitName(unitName: string, valueType: string): string {
    let unit = unitName;
    if (valueType === ValueTypes.relativeDeviation.key) {
        unit = '%';
    }
    return unit;
}